export default __webpack_public_path__ + "static/media/intermid_ml.730f9d5f.svg";